export default "__VITE_ASSET__kWjunziu__"